import React from "react"
import { AnalyticsThemeProvider } from "@ui-seeker/app"

import overrideComponents from "./overrides"
import { rentacarPalette } from "./palette"

export default function AppTheme({ children }) {
	return <AnalyticsThemeProvider
		global={{
			html: { fontSize: 13 }
		}}
		overrides={overrideComponents}
		palette={rentacarPalette}>
		{children}
	</AnalyticsThemeProvider>
}

